import type { LegacyCaseDetail } from "../types/legacyCases";

interface LegacySourceSelection {
  sourceRowId: string;
  reportDocumentId: string;
  extractionId: string;
}

export function selectedLegacySourceComparison(
  detail: LegacyCaseDetail,
  selection: LegacySourceSelection
) {
  const extractionId =
    selection.extractionId ||
    detail.extractions.find(
      (extraction) => extraction.documentId === selection.reportDocumentId
    )?.id;
  return detail.sourceComparisons?.find(
    (comparison) =>
      comparison.sourceRowId === selection.sourceRowId &&
      comparison.reportDocumentId === selection.reportDocumentId &&
      comparison.extractionId === extractionId
  );
}

export function requiresLegacySourceAcknowledgment(
  detail: LegacyCaseDetail,
  selection: LegacySourceSelection
) {
  return (
    detail.hasConflicts ||
    Boolean(
      selectedLegacySourceComparison(detail, selection)?.requiresAcknowledgment
    )
  );
}
